<style>
.clickable {
  cursor: pointer;
}
.clickable:hover {
  text-decoration: underline;
}
@media (min-width: 1200px) {
  .right-border {
    border-right: solid 1px;
  }
}
.active-setting {
  font-weight: 550;
  font-style: italic;
}
</style>
<template>
  <div class="card">
    <div class="card-header bg-primary text-light">
      <span class="d-xl-none" @click="setNavigation({}, true)">
        <i class="fa fa-arrow-left clickable"></i> |
      </span>
      Einstellungen / <span v-html="currentNavigation.title"></span>
    </div>
    <div class="card-body text-primary">
      <div class="row">
        <div
          class="col-12 col-xl-3 right-border"
          :class="{
            'd-none d-xl-block': Object.keys(currentNavigation).length
          }"
        >
          <label class="text-lg">
            <strong>Was möchtest du Einstellen?</strong>
          </label>
          <ul class="list-group pl-3 list-unstyled">
            <li
              v-for="(navigation, key) in navigations"
              :key="key"
              class="pt-3 text-md clickable"
              :class="{ 'active-setting': currentNavigation == navigation }"
              @click="setNavigation(navigation)"
            >
              <span v-html="navigation.title"></span>
            </li>
          </ul>
        </div>
        <div class="col-12 col-xl-9">
          <component
            v-if="Object.keys(currentNavigation).length"
            :is="currentNavigation.component"
            @set-navigation-key="setNavigationKey"
          >
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Delete from "./Delete.vue";
import Email from "./Email.vue";
import Notification from "./Notification.vue";
import Password from "./Password.vue";
import Profile from "./Profile.vue";
import NotificationTelegram from "./NotificationTelegram.vue";

export default {
  components: {
    Delete,
    Email,
    Notification,
    Password,
    Profile,
    NotificationTelegram
  },
  data() {
    return {
      currentNavigation: {},
      navigations: [
        { title: "Profil bearbeiten", component: "Profile" },
        { title: "E-Mail-Adresse ändern", component: "Email" },
        { title: "Passwort ändern", component: "Password" },
        { title: "Benachrichtungen", component: "Notification" },
        { title: "Profil löschen", component: "Delete" }
      ]
    };
  },
  created() {
    if (this.telegram) {
      this.navigations.push({
        title: `<img height="16" src="/assets/images/telegram.png" alt=""> Benachrichtungen über Telegram`,
        component: "NotificationTelegram"
      });
    }
    if (window.innerWidth >= 1200) {
      this.currentNavigation = this.navigations[0];
    }
  },
  methods: {
    setNavigationKey(key) {
      this.currentNavigation = this.navigations[key];
    },
    setNavigation(navigation, redirectChat = false) {
      if (redirectChat && !Object.keys(this.currentNavigation).length) {
        window.location.href = "/chat";
      }
      this.currentNavigation = navigation;
    }
  },
  computed: {
    telegram() {
      return Laravel.settings.messengers.telegram.active;
    }
  }
};
</script>
